/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { MassAction } from './types'

/** Trailing actions always appear at the end of the bar in this order. */
const TRAILING_ACTION_KEYS = ['bulkReminder', 'export', 'delete'] as const

export const orderMassActionsForBar = <TRow,>(actions: MassAction<TRow>[]): MassAction<TRow>[] => {
    if (actions.length <= 1) {
        return actions
    }

    const trailingKeySet = new Set<string>(TRAILING_ACTION_KEYS)
    const leading = actions.filter((action) => !trailingKeySet.has(action.key))

    const trailing = TRAILING_ACTION_KEYS.map((key) =>
        actions.find((action) => action.key === key)
    ).filter((action): action is MassAction<TRow> => Boolean(action))

    return [...leading, ...trailing]
}
